export default {
  "title": "Notification Center",
  "description": "Your latest security and system alerts.",
  "total": "Total {{formattedCount}}",
  "unreadCount": "Unread {{formattedCount}}",
  "readCount": "Read {{formattedCount}}",
  "recent": "Showing most recent {{visible}} of {{total}}.",
  "refresh": "Refresh",
  "markAllRead": "Mark all read",
  "dismissRead": "Dismiss read",
  "all": "All notifications",
  "allDescription": "Browse, filter, and manage alerts.",
  "details": "Notification details",
  "unread": "Unread",
  "read": "Read",
  "unreadNotification": "Unread notification",
  "opensNewTab": "(opens in new tab)",
  "collapse": "Collapse",
  "expand": "Expand",
  "collapseNotification": "Collapse notification",
  "expandNotification": "Expand notification",
  "markRead": "Mark read",
  "markUnread": "Mark unread",
  "dismiss": "Dismiss",
  "dismissNotification": "Dismiss notification",
  "search": "Search notifications...",
  "actions": "Actions",
  "empty": "No notifications found.",
  "type": "Type",
  "category": "Category",
  "notification": "Notification",
  "source": "Source",
  "system": "System",
  "admin": "Admin",
  "automated": "Automated",
  "created": "Created",
  "date": "Date",
  "status": "Status",
  "last24Hours": "Last 24 hours",
  "last7Days": "Last 7 days",
  "last30Days": "Last 30 days",
  "general": "General",
  "applications": "Applications",
  "support": "Support",
  "security": "Security",
  "sessions": "Sessions",
  "securityToken": "Missing security token. Refresh the page.",
  "loadFailed": "Unable to load notifications.",
  "markReadFailed": "Unable to mark notifications as read.",
  "markUnreadFailed": "Unable to mark notifications as unread.",
  "dismissFailed": "Unable to dismiss notifications.",
  "preferencesLoadFailed": "Unable to load notification settings.",
  "preferencesSaveFailed": "Unable to save settings.",
  "actionNotAllowed": "Action not allowed.",
  "signInAgain": "Please sign in again.",
  "savedLocally": "Settings could not be saved to the server. A local copy was kept in this browser. {{message}}",
  "notSavedLocally": "Settings could not be saved to the server or this browser. Your changes remain unsaved on this page. Try saving again before leaving. {{message}}"
} as const;
